export type SortDirection = 'asc' | 'desc';

export enum FilterType {
  TEXT = 'text',
  SELECT = 'select',
  SINGLE_SELECT = 'single_select',
  CI_SELECT = 'ci_select',
  CI_SINGLE_SELECT = 'ci_single_select',
  NUMBER = 'number',
  DATE = 'date',
}
